import { Typography } from "@drone-js/core";
import { VStack } from "../../commons/components/Stack.tsx";
import { useStaticDataAtomValue } from "../staticDataAtom.ts";
import { PhotosController } from "./PhotosController.tsx";

export const PropertyPhotosController = () => {
    const {
        cmsData: {
            photo: { propertyPhotos, showcasePropertyWithPhotos },
        },
    } = useStaticDataAtomValue();

    return (
        <VStack gap="24">
            <VStack gap="8">
                <Typography variant="heading-l" textColor="base.default">
                    {propertyPhotos}
                </Typography>
                <Typography variant="body-s" textColor="base.subtle">
                    {showcasePropertyWithPhotos}
                </Typography>
            </VStack>
            <PhotosController />
        </VStack>
    );
};
